import { Button } from '@/components/buttons/button';
import Link from 'next/link';

interface ErrorPageProps {
  title?: string;
  message?: string;
  code?: number;
  action?: {
    label: string;
    href: string;
  };
}

export default function ErrorPage({
  title = 'Something went wrong',
  message = 'We encountered an unexpected error.',
  code,
  action = {
    label: 'Go back home',
    href: '/'
  }
}: ErrorPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-4">
      {code && (
        <h1 className="text-6xl font-bold text-gray-900 mb-4">
          {code}
        </h1>
      )}
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">
        {title}
      </h2>
      <p className="text-gray-600 text-center mb-8 max-w-md">
        {message}
      </p>
      <Link href={action.href}>
        <Button>
          {action.label}
        </Button>
      </Link>
    </div>
  );
} 